module.exports = __webpack_public_path__ + "6c4a0dbc/img/archive-icon.0a6a9de3.svg";